import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { trackChunkLoadErrors } from './lib/chunkReload.ts';
import './styles/globals.css';

// A tab left open across a deploy asks for chunks the deploy retired. Tag those
// failures so ChunkErrorBoundary (App.tsx) can reload once instead of going white.
trackChunkLoadErrors(window);

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

createRoot(el).render(
  <StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <App />
    </BrowserRouter>
  </StrictMode>,
);
